// extracted by mini-css-extract-plugin
module.exports = {"promo-code-banner":"PromoCodeBanner_promo-code-banner__Zi90y"};